import { useContext } from 'react';
import { __RouterContext, RouteComponentProps } from 'react-router';

// The react-router guys say that this will be what the official API probably looks like
// https://github.com/ReactTraining/react-router/pull/6453#issuecomment-474600561

export function useRouter<P extends {}>() {
    const context = useContext(__RouterContext) as RouteComponentProps<P>;
    return context;
}

export const useLocation = () => {
    const context = useContext(__RouterContext);
    return context.location;
};

export function useMatch<P extends {}>() {
    const context = useContext(__RouterContext) as RouteComponentProps<P>;
    return context.match;
}

export function useHistory() {
    const context = useContext(__RouterContext);
    return context.history;
}
